import { useMutation } from '@tanstack/react-query';

import { postCompanyQuestion } from './fetchPostCompanyQuestion';

export function useCompanyQuestionMutation() {
  const { mutateAsync, isPending } = useMutation({
    mutationFn: postCompanyQuestion,
  });

  return {
    postCompanyQuestion: mutateAsync,
    isLoading: isPending,
  };
}
